module.exports = __webpack_public_path__ + "img/summary_icon.3d43690a.png";